import audio1ST from '../../assets/testominial audios/1ST.wav';
import audio2ND from '../../assets/testominial audios/2ND.wav';
import audio3RD from '../../assets/testominial audios/3RD.wav';
import audio4TH from '../../assets/testominial audios/4TH.wav';
import audio5TH from '../../assets/testominial audios/5TH.wav';
import audio6TH from '../../assets/testominial audios/6TH.wav';
import audio7TH from '../../assets/testominial audios/7TH.wav';
import audio8TH from '../../assets/testominial audios/8TH.wav';

/** Maps testimonial id → bundled clip (order matches legacy index-based pairing). */
const BUNDLED_AUDIO_BY_ID = {
  1: audio1ST,
  2: audio2ND,
  3: audio3RD,
  5: audio4TH,
  6: audio5TH,
  7: audio6TH,
  8: audio7TH,
  10: audio8TH,
};

/** Default quotes shown on Home + Case Studies listing (admin can override via CMS). */
export let HOME_TESTIMONIALS = [
  {
    id: 1,
    quote:
      '"Databiqs Delivered An AI Solution That Significantly Improved Our Customer Response Time And Operational Efficiency. Their Approach Was Strategic, Professional, And Results-Driven."',
    audioUrl: '',
    authorName: 'Ahmed Raza',
    authorRole: 'CTO, XYZ Logistics'
  },
  {
    id: 2,
    quote:
      '"Databiqs Helped Us Modernize Our Customer Experience With AI-First Automation, Delivering Faster Service And Better Decision-Making Across Teams."',
    audioUrl: '',
    authorName: 'Sarah Jenkins',
    authorRole: 'Head of Operations, FinServe Inc'
  },
  {
    id: 3,
    quote:
      '"The AI Automation Implemented By Databiqs Streamlined Our Internal Workflows And Reduced Manual Effort Across Teams. Their Expertise With Intelligent Systems Truly Stands Out."',
    audioUrl: '',
    authorName: 'Michael Chang',
    authorRole: 'Director of IT, NovaTech Solutions'
  },
  {
    id: 5,
    quote:
      '"Working With Databiqs Has Been Transformative For Our Business. Their AI Solutions Enabled Us To Automate Key Processes And Scale Effortlessly Across All Departments."',
    audioUrl: '',
    authorName: 'Elena Rodriguez',
    authorRole: 'COO, HealthSync Partners'
  },
  {
    id: 6,
    quote:
      '"The Intelligent Automation Platform Deployed By Databiqs Reduced Our Operational Costs By 40%. Their Team Was Knowledgeable, Responsive, And Truly Invested In Our Success."',
    audioUrl: '',
    authorName: 'David O\'Connor',
    authorRole: 'VP of Engineering, BuildSmart'
  },
  {
    id: 7,
    quote:
      '"Databiqs Understood Our Unique Challenges And Delivered A Tailored AI Solution That Exceeded Expectations. The Results Were Measurable Within The First Month."',
    audioUrl: '',
    authorName: 'Ayesha Khan',
    authorRole: 'Marketing Director, RetailPlus'
  },
  {
    id: 8,
    quote:
      '"From Initial Consultation To Full Deployment The Databiqs Team Was Professional And Thorough. Their AI Tools Gave Us A Competitive Edge We Did Not Expect So Quickly."',
    audioUrl: '',
    authorName: 'James Wilson',
    authorRole: 'CEO, Nexus Analytics'
  },
  {
    id: 10,
    quote:
      '"The Team At Databiqs Brought Both Technical Depth And Strategic Vision. Their AI Solutions Integrated Seamlessly With Our Existing Systems And Delivered Real ROI."',
    audioUrl: '',
    authorName: 'Robert Mueller',
    authorRole: 'Chief Innovation Officer, GlobalTrade'
  },
];

export function resolveTestimonialAudio(item) {
  const url = typeof item?.audioUrl === 'string' ? item.audioUrl.trim() : '';
  if (url) return url;
  return BUNDLED_AUDIO_BY_ID[item?.id] ?? null;
}

export function withTestimonialAudio(items) {
  return (items || []).map((item) => ({
    ...item,
    audio: resolveTestimonialAudio(item),
  }));
}

export function hydrateHomeTestimonials(items) {
  if (Array.isArray(items) && items.length) {
    HOME_TESTIMONIALS = items.map((item) => ({
      id: item.id,
      quote: item.quote ?? '',
      audioUrl: item.audioUrl ?? '',
      authorName: item.authorName ?? '',
      authorRole: item.authorRole ?? '',
    }));
  }
}
